export const get = (state) => {
  return _.sortBy(state.categories, [
    category => category.description.slice(3)
  ])
}

export const getCustom = (state) => {
  return _.sortBy(state.customCategories, [
    category => category.description.slice(3)
  ])
}

export const getById = (state) => (id) => {
  return state.categories.find(category => category.id === id)
}

export const getCustomById = (state) => (id) => {
  return state.customCategories.find(category => category.id === id)
}